import { Component, OnInit } from '@angular/core';
import { IAccTooltipRenderEventArgs } from '@syncfusion/ej2-angular-charts';
import { TopBarService } from 'src/app/top-bar/top-bar.service';
import { DashboardService } from './dashboard.service';
import { CHART_LOCATION_COLOR, CHART_CMR_COLOR, CHART_EDNA_COLOR, CHART_ACOUSTIC_COLOR } from '../../constant';

@Component({
  selector: 'restoreid-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})

export class DashboardComponent implements OnInit {

  constructor(
    private _topBarService: TopBarService,
    private _dashboardService: DashboardService,
  ) {
    this._topBarService.setTitle('Dashboard');
  }

  public tooltip?: Object;
  public palette: string[] = [CHART_LOCATION_COLOR, CHART_CMR_COLOR, CHART_EDNA_COLOR, CHART_ACOUSTIC_COLOR];;

  // Entity Total chart
  public cEntityTotalPrimaryXAxis?: Object;
  public cEntityTotalData?: Object[];
  public cEntityTotalTitle?: string;
  public cEntityTotalPrimaryYAxis?: Object;
  public cEntityTotalCornerRadius?: Object;
  public cEntityTotalArea?: Object;
  public cEntityTotalColorMapping?: string;

  //Survey Total chart
  public cSurveyTotalData?: Object[];
  public cSurveyTotalLegendSettings?: Object;
  public cSurveyTotalDataLabel?: Object;
  public cSurveyTotalTitle?: Object;
  public cSurveyTotalPalette?: string[];
  public cSurveyTotalTooltipRender(args: IAccTooltipRenderEventArgs): void {
    let value  = args.point.y / args.series.sumOfPoints * 100;
    args["text"] = args.point.x + ' : ' + Math.ceil(value) + '' + '%';
 };

  // Survey Group chart
  public cSurveyGroupPrimaryXAxis?: Object;
  public cSurveyGroupData?: Object[];
  public cSurveyGroupTitle?: string;
  public cSurveyGroupPrimaryYAxis?: Object;

  async ngOnInit() {
    await this._loadEntityTotalChart();
    await this._loadSurveyTotalChart();
    await this._loadSurveyGroupChart();

    this.tooltip = {
      enable: true
    };
  }

  private async _loadEntityTotalChart() {
    await this._dashboardService.getEntityTotalChart().then((data: any[]) => {
      this.cEntityTotalData = data.map((item, index) => ({
        ...item,
        color: this.palette[index], // Assign colors cyclically
      }));
    });

    this.cEntityTotalPrimaryXAxis = {
      valueType: 'Category',
      majorGridLines: { width: 0 },
      title: 'Entities'
    };
    this.cEntityTotalPrimaryYAxis = {
      lineStyle: { width: 0 },
      majorTickLines: { width: 0 },
      minorTickLines: { width: 0 },
      title: 'Count',
      minimum: 0,
      interval: 20,
    };
    this.cEntityTotalTitle = 'Entities Count - Total';
    this.cEntityTotalArea = {
        border: {
            width: 0
        }
    };
    this.cEntityTotalCornerRadius = {
        topLeft: 10, topRight: 10
    };
    this.cEntityTotalColorMapping = "color";
  }

  private async _loadSurveyTotalChart(){
    this.cSurveyTotalData = await this._dashboardService.getSurveyTotalChart();
    this.cSurveyTotalLegendSettings = {
      visible: false
    };
    this.cSurveyTotalDataLabel = { visible: true };
    this.cSurveyTotalTitle = 'Survey Type Count - Total';
    this.cSurveyTotalPalette = [CHART_CMR_COLOR, CHART_EDNA_COLOR, CHART_ACOUSTIC_COLOR];
  }

  private async _loadSurveyGroupChart() {
    this.cSurveyGroupData = await this._dashboardService.getSurveyGroupChart();
    this.cSurveyGroupPrimaryXAxis = {
        valueType: 'Category',
        title: 'Groups'
    };
    this.cSurveyGroupPrimaryYAxis = {
        minimum: 0,
        interval: 20,
        title: 'Count'
    };
    this.cSurveyGroupTitle = 'Survey Type Count - Group';
  }
}
